/**
 * Phase A5 Firestore collection security (main app mirror).
 * Mirror: backend/src/config/firestoreCollectionSecurity.ts
 */

export const FIRESTORE_CARRIERS_COLLECTION = 'carriers' as const;

export const FIRESTORE_CARRIER_METRICS_COLLECTION = 'carrier_metrics' as const;

export const FIRESTORE_LOADS_COLLECTION = 'loads' as const;

export const FIRESTORE_BROKER_LOADS_COLLECTION = 'brokerLoads' as const;

export const FIRESTORE_INVOICES_COLLECTION = 'invoices' as const;

export const FIRESTORE_METRICS_COLLECTION = 'metrics' as const;

export const FIRESTORE_BROKER_METRICS_COLLECTION = 'brokerMetrics' as const;

export const FIRESTORE_BROKER_COMPANIES_COLLECTION = 'brokerCompanies' as const;

export const FIRESTORE_LOCATIONS_COLLECTION = 'locations' as const;

export const FIRESTORE_ELD_LOCATIONS_COLLECTION = 'eldLocations' as const;

export const FIRESTORE_LOCATION_VISIBLE_TO_FIELD = 'visibleToUserIds' as const;

export const FIRESTORE_PURCHASE_ORDERS_COLLECTION = 'purchaseOrders' as const;

export const FIRESTORE_BROKER_PURCHASE_ORDERS_COLLECTION = 'brokerPurchaseOrders' as const;

export const FIRESTORE_PO_ARCHIVE_COLLECTION = 'poArchive' as const;

export const FIRESTORE_PO_MARKETPLACE_FLAG = 'isMarketplace' as const;

export const FIRESTORE_NOTIFICATIONS_COLLECTION = 'notifications' as const;

export const FIRESTORE_PARTNER_REQUESTS_COLLECTION = 'partnerRequests' as const;

export const FIRESTORE_BROKER_NOTIFICATIONS_COLLECTION = 'brokerNotifications' as const;

export const FIRESTORE_LOAD_PARTY_FIELD_USER_ID = 'userId' as const;

export const FIRESTORE_LOAD_PARTY_FIELD_SHIPPER_ID = 'shipperId' as const;

export const FIRESTORE_LOAD_PARTY_FIELD_BROKER_ID = 'brokerId' as const;

export const FIRESTORE_LOAD_PARTY_FIELD_CARRIER_ID = 'carrierId' as const;

export const FIRESTORE_LOAD_MARKETPLACE_FLAG = 'isMarketplace' as const;

/** Rules-safe carrier marketplace browse query (Phase A5 — matches loadMarketplaceListingMayRead). */
export const FIRESTORE_MARKETPLACE_OPEN_LISTING_IS_MARKETPLACE = true as const;

export const FIRESTORE_MARKETPLACE_OPEN_LISTING_CARRIER_ID = null;

/** Write on load + PO docs when posting an open marketplace listing (browse query + batch-exists). */
export const MARKETPLACE_OPEN_LISTING_DOC_FIELDS = {
  isMarketplace: FIRESTORE_MARKETPLACE_OPEN_LISTING_IS_MARKETPLACE,
  carrierId: FIRESTORE_MARKETPLACE_OPEN_LISTING_CARRIER_ID,
} as const;

/** Write when a load/PO must leave the carrier marketplace browse board (cancel/complete/archive). */
export const MARKETPLACE_CLOSED_LISTING_DOC_FIELDS = {
  isMarketplace: false,
} as const;

export const FIRESTORE_MARKETPLACE_OPEN_LISTING_QUERY_LIMIT = 400 as const;

export const FIRESTORE_MARKETPLACE_OPEN_LISTING_ORDER_FIELD = 'createdAt' as const; // client-side sort only

export const FIRESTORE_RULE_HELPER_CARRIER_LEGACY_DOC_READ = 'carrierLegacyDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_CARRIER_METRICS_READ = 'carrierMetricsDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_LOAD_DOC_READ = 'loadDocReadAllowed' as const;

export const FIRESTORE_RULE_HELPER_LOAD_PARTY_READ = 'loadDocPartyMayRead' as const;

export const FIRESTORE_RULE_HELPER_LOAD_MARKETPLACE_READ = 'loadMarketplaceListingMayRead' as const;

export const FIRESTORE_RULE_HELPER_BROKER_LOAD_DOC_READ = 'brokerLoadDocReadAllowed' as const;

export const FIRESTORE_RULE_HELPER_BROKER_LOAD_MARKETPLACE_READ =
  'brokerLoadMarketplaceListingMayRead' as const;

export const FIRESTORE_RULE_HELPER_INVOICE_DOC_READ = 'invoiceDocReadAllowed' as const;

export const FIRESTORE_RULE_HELPER_METRICS_DOC_READ = 'metricsDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_BROKER_METRICS_DOC_READ = 'brokerMetricsDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_BROKER_COMPANY_DOC_READ = 'brokerCompanyDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_LOAD_DOC_CREATE = 'loadDocCreateAsSelfAllowed' as const;

export const FIRESTORE_RULE_HELPER_NOTIFICATION_DOC_READ = 'notificationDocPartyMayRead' as const;

export const FIRESTORE_RULE_HELPER_NOTIFICATION_DOC_DELETE = 'notificationDocPartyMayDelete' as const;

export const FIRESTORE_RULE_HELPER_PARTNER_REQUEST_DOC_READ = 'partnerRequestDocPartyMayRead' as const;

export const FIRESTORE_RULE_HELPER_BROKER_NOTIFICATION_DOC_READ =
  'brokerNotificationDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_PURCHASE_ORDER_DOC_READ =
  'purchaseOrderDocReadAllowed' as const;

export const FIRESTORE_RULE_HELPER_BROKER_PURCHASE_ORDER_DOC_READ =
  'brokerPurchaseOrderDocReadAllowed' as const;

export const FIRESTORE_RULE_HELPER_LOCATION_DOC_READ = 'locationDocMayRead' as const;

export const FIRESTORE_LOAD_FIELD_REMAINING_LOADS = 'remainingLoads' as const;

export const FIRESTORE_RULE_HELPER_LOAD_DOC_CREATOR_WRITE = 'loadDocCreatorMayWrite' as const;

export const FIRESTORE_RULE_HELPER_PURCHASE_ORDER_DOC_CREATOR_WRITE =
  'purchaseOrderDocCreatorMayWrite' as const;

export const FIRESTORE_BROKER_SHIPPING_SCHEDULES_COLLECTION = 'brokerShippingSchedules' as const;

export const FIRESTORE_SHIPPING_SCHEDULES_COLLECTION = 'shippingSchedules' as const;

export const FIRESTORE_RULE_HELPER_BROKER_SHIPPING_SCHEDULE_DOC_READ =
  'brokerShippingScheduleDocMayRead' as const;

export const FIRESTORE_RULE_HELPER_SHIPPING_SCHEDULE_DOC_READ =
  'shippingScheduleDocMayRead' as const;

export const FIRESTORE_CARRIER_LEGACY_CLIENT_READ_VIA_API_ONLY = true as const;
